/**
 * PilotMask component.
 */
import BottomMask from '@components/atoms/mask/pilotBottomMask';
import TopMask from '@components/atoms/mask/pilotTopMask';

/**
 * Displays the pilot mask component. Includes the top and bottom gradients.
 */
export default function PilotMask() {
  return (
    <>
      <TopMask />
      <BottomMask />
    </>
  );
}
